module.exports = __webpack_public_path__ + "img/id_front.6cc1053.webp";